import API from "..";

export default class ShippingReason {

  constructor({
    shippingReasonName,
    isActive
  }) 
    
  {
    this.shippingReasonName = shippingReasonName;
    this.isActive = isActive;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/shippingReason`);
    if (data.result) {
        return data.result.map((d) => new ShippingReason(d));
    }
    else {
        return [];
    }
  }

  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/shippingReason`);
    if (data && data.result && data.result.length > 0) {
        return data.result.filter((d) => d.isActive);
    }
    else {
        return [];
    }
  }
}
